import { BannerGlobalConfigsState } from "./types";

export const bannerGlobalConfigsSelectors = {
  getPwaBannerStatus: (state: BannerGlobalConfigsState) =>
    state.isPwaBannerEnabled,
};
